module.exports = __webpack_public_path__ + "img/vehicle-add-update.6bf7afee.svg";